import { calculateDiscountAmount } from "..";
// deprecated pod 쿠폰 리팩토링이 완료되면 삭제 예정
export const calculateDiscount = (item, coupon)=>{
    if (!coupon) return 0;
    let discount = 0;
    if (coupon.discountType === "percent") {
        discount = Math.floor(item.pod.options.price * coupon.discountValue / 100);
    } else if (coupon.discountType === "amount") {
        discount = coupon.discountValue;
    }
    discount = Math.min(discount, item.pod.options.price);
    if (coupon.discountMaximumPrice) {
        discount = Math.min(discount, coupon.discountMaximumPrice);
    }
    return discount;
};
export const validateCoupon = (item, coupon, allowedProductIds)=>{
    if (!item || !coupon) {
        return {
            isValid: false,
            reason: "상품 또는 쿠폰이 없습니다."
        };
    }
    if (allowedProductIds && !allowedProductIds.includes(item.id)) {
        return {
            isValid: false,
            reason: "쿠폰 적용이 불가능한 상품입니다."
        };
    }
    const itemPrice = item.pod.options.price;
    // 쿠폰 적용 최소 금액 검증
    if (coupon.minimumPrice && itemPrice < coupon.minimumPrice) {
        return {
            isValid: false,
            reason: "적용실패 (최소 사용금액 조건 미달)"
        };
    }
    const discount = calculateDiscountAmount({
        price: itemPrice,
        discountType: coupon.discountType,
        discountValue: coupon.discountValue,
        discountMaximumPrice: coupon.discountMaximumPrice
    });
    if (parseInt(discount) > itemPrice) {
        return {
            isValid: false,
            reason: "다른 쿠폰을 사용해주세요."
        };
    }
    return {
        isValid: true,
        discount: parseInt(discount)
    };
};
